/*
    Component for Google Places auto Complete.
    used in job create and company Create.

    returns full location object if user
    picks any of the option.

    takes in string for the location to render into the field.
*/
import React from 'react';

import { Input } from 'reactstrap';

class GoogleAddressAutocomplete extends React.Component {
   constructor(props) {
      super(props);
      this.state = this.initialState();
      // this.handleChange = this.handleChange.bind(this);
      this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
   }

   initialState() {
      return {
         name: '',
         street_address: this.props.address ? this.props.address : '',
         city: '',
         state: '',
         zip: '',
         latitude: '',
         longitude: '',
      };
   }

   componentDidMount() {
      if (window.google) {
         this.autocomplete = new window.google.maps.places.Autocomplete(document.getElementById('LocationAutoComplete'), { types: ['address'], componentRestrictions: { country: 'us' } });
         this.autocomplete.addListener('place_changed', this.handlePlaceSelect);
      }
   }

   handlePlaceSelect() {
      let addressObject = this.autocomplete.getPlace();
      let address = addressObject.address_components;
      if (addressObject && addressObject.name) {
         this.setState({
            name: addressObject.name,
            street_address: `${ address[0].long_name } ${ address[1].long_name }`,
            city: address[2].long_name,
            state: address[4].short_name,
            zip_code: address[6].short_name,
            latitude: addressObject.geometry.location.lat(),
            longitude: addressObject.geometry.location.lng(),
         }, () => {
            this.updateAddress();
         });
      } else {
      }
   }

   updateAddress() {
      if (this.props.onChange) {
         this.props.onChange(Object.assign({}, ...this.state));
      }
   }

   render() {
      return (
         <div>
            <Input id='LocationAutoComplete' ref='input' type='text' defaultValue={this.state.street_address}/>
         </div>
      );
   }
}

export default GoogleAddressAutocomplete;
